import { useEffect } from 'react';

const FALLBACK_TITLE = 'Vasapon Opaswatanakul | Portfolio';
const FALLBACK_DESCRIPTION = 'A data-driven content designer, writing and designing to solve real problems.';
const FALLBACK_IMAGE = 'https://www.vasapon.space/cover.png';

function setMetaName(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaProperty(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function usePageMeta({ title, description, ogType = 'website', ogImage, ogUrl, authorName } = {}) {
  useEffect(() => {
    const t = title || FALLBACK_TITLE;
    const d = description || FALLBACK_DESCRIPTION;
    const img = ogImage || FALLBACK_IMAGE;

    document.title = t;
    setMetaName('description', d);
    setMetaProperty('og:type', ogType);
    setMetaProperty('og:title', t);
    setMetaProperty('og:description', d);
    setMetaProperty('og:image', img);
    if (ogUrl) setMetaProperty('og:url', ogUrl);
    setMetaName('twitter:card', 'summary_large_image');
    setMetaName('twitter:title', t);
    setMetaName('twitter:description', d);
    setMetaName('twitter:image', img);
    if (authorName) setMetaName('author', authorName);
  }, [title, description, ogType, ogImage, ogUrl, authorName]);
}
